import React from 'react';
import PropTypes from 'prop-types';

const ccView = (ccNumber) => {
  const cleaned = (ccNumber || '').replace(/.(?=.{4})/g, 'X');
  return cleaned;
};

const View = ({
  payeeCardNum,
  payeeCardName,
  payeeRenter,
  payeeFirstName,
  payeeLastName,
  payeeCompany,
  payeeAddress,
  payeeCity,
  payeeState,
  payeeZip,
  payeeCountry,
  show,
}) =>
  (show && (
    <>
      <p className="font-weight-bold">Credit Card</p>
      <div>{payeeCardName}</div>
      <div>{ccView(payeeCardNum)}</div>

      <p className="font-weight-bold mt-3">Billing to</p>
      {payeeRenter}
      {payeeRenter ? (
        <p>{payeeCompany}</p>
      ) : (
        <p>{`${payeeFirstName} ${payeeLastName}`}</p>
      )}
      <p>{payeeAddress}</p>
      <p>{`${payeeCity}, ${payeeState}, ${payeeZip}, ${payeeCountry}`}</p>
    </>
  )) || <></>;
View.propTypes = {
  payeeCardNum: PropTypes.string.isRequired,
  payeeCardName: PropTypes.string.isRequired,
  payeeRenter: PropTypes.bool.isRequired,
  payeeFirstName: PropTypes.string.isRequired,
  payeeLastName: PropTypes.string.isRequired,
  payeeCompany: PropTypes.string.isRequired,
  payeeAddress: PropTypes.string.isRequired,
  payeeCity: PropTypes.string.isRequired,
  payeeState: PropTypes.string.isRequired,
  payeeZip: PropTypes.string.isRequired,
  payeeCountry: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default View;
